import { createClient, type Session } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anon) {
  // Don't throw — boot should succeed in dev when these are blank. Auth
  // pages will render a "Supabase not configured" banner instead.
  console.warn('[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY not set');
}

export const supabase = createClient(url ?? 'http://localhost', anon ?? 'anon-key-unset', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: 'athena.auth',
    flowType: 'pkce',
  },
});

export const isSupabaseConfigured = Boolean(url && anon);

export async function getAccessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}

export type { Session };
